import { EventBus } from '@primeuix/utils/eventbus';

var DynamicDialogEventBus = EventBus();

export { DynamicDialogEventBus as default };
//# sourceMappingURL=index.mjs.map
